/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { ResponsePath } from './ResponsePath';
import { ResponsePathFromJSON, ResponsePathFromJSONTyped, ResponsePathToJSON } from './ResponsePath';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerCustomApi
 */
export interface SingleTurnChatInferencerCustomApi {
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  endpointUrl: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  method: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  requestTemplate: string;
  /**
   *
   * @type {Array<ResponsePath>}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  readonly responsePaths: Array<ResponsePath>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof SingleTurnChatInferencerCustomApi
   */
  otherHeaders?: { [key: string]: string } | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerCustomApi interface.
 */
export function instanceOfSingleTurnChatInferencerCustomApi(value: object): value is SingleTurnChatInferencerCustomApi {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('endpointUrl' in value) || value['endpointUrl'] === undefined) return false;
  if (!('method' in value) || value['method'] === undefined) return false;
  if (!('requestTemplate' in value) || value['requestTemplate'] === undefined) return false;
  if (!('responsePaths' in value) || value['responsePaths'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerCustomApiFromJSON(json: any): SingleTurnChatInferencerCustomApi {
  return SingleTurnChatInferencerCustomApiFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerCustomApiFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerCustomApi {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    endpointUrl: json['endpoint_url'],
    method: json['method'],
    requestTemplate: json['request_template'],
    responsePaths: (json['response_paths'] as Array<any>).map(ResponsePathFromJSON),
    otherHeaders: json['other_headers'] == null ? undefined : json['other_headers'],
  };
}

export function SingleTurnChatInferencerCustomApiToJSON(
  value?: Omit<SingleTurnChatInferencerCustomApi, 'id' | 'credential' | 'responsePaths'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    endpoint_url: value['endpointUrl'],
    method: value['method'],
    request_template: value['requestTemplate'],
    other_headers: value['otherHeaders'],
  };
}
